module.exports = __webpack_public_path__ + "img/gift1.bd71998f.png";